// Line shaped progress bar
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';

import css from '../css/line.m.css';

export interface LineProperties {
	progress: number;
	total: number;
	title?: string;
}

const SET_COLOR = 'currentColor';
const UNSET_COLOR = 'rgb(255, 255, 255)';

@theme(css)
export class Line extends I18nThemed<LineProperties> {
	protected linearGradient(gradientId: string): DNode {
		const { progress, total } = this.properties;
		const percent = (progress / total) * 100;
		const s1 = percent > 0 ? SET_COLOR : UNSET_COLOR;
		const s2 = s1;
		const s3 = percent < 99 ? UNSET_COLOR : SET_COLOR;
		const s3offset = Math.min(percent + 10, 100);

		return v('defs', { key: 'defs' }, [
			v('linearGradient', { id: gradientId, x1: '0%', y1: '0%', x2: '100%', y2: '0%' }, [
				v('stop', { key: 's1', offset: '0%', style: `stop-color:${s1};stop-opacity:1` }),
				v('stop', { key: 's2', offset: `${percent}%`, style: `stop-color:${s2};stop-opacity:1` }),
				v('stop', { key: 's3', offset: `${s3offset}%`, style: `stop-color:${s3};stop-opacity:1` })
			])
		]);
	}

	protected render(): DNode {
		const { key = 'pbline', title, progress, total } = this.properties;
		const prgdivider = '\u2005\u2223\u2005';
		const gradientId = `gradient1-${key}`;
		const titleId = `${key}TitleId`;
		const ariaTitle = title ? `${title}: ${progress} of ${total}` : `${progress} of ${total}`;
		const legend = `${progress}${prgdivider}${total}`;

		return v('div', { key, classes: [this.theme(css.root)] }, [
			v('svg', { viewBox: `0 0 116 50`, preserveAspectRatio: 'none', role: 'img', 'aria-labelledby': titleId }, [
				v('title', { key: 'pb0', id: titleId }, [ariaTitle]),
				this.linearGradient(gradientId),
				title && v('text', { key: 'pb1', x: '55', classes: [this.theme(css.title)] }, [title]),
				v('rect', {
					classes: [this.theme(css.progressBar)],
					key: 'pb2',
					width: '116',
					height: '9',
					fill: `url(#${gradientId})`
				}),
				v('text', { key: 'pb3', x: '55', y: '48', classes: [this.theme(css.legend)] }, [legend])
			])
		]);
	}
}

export default Line;
